import React from 'react';

export default function WebsiteMessages() {
  return <div>WebsiteMessages</div>;
}
